import React from "react";
import { PostListJourneyLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/PostListJourneyLayout";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { BlockSkeleton } from "@companion-core/shared/app/Components/Skeletons/BlockSkeleton/BlockSkeleton";
import { useJourneySlides } from "@companion-core/shared/app/Components/Blocks/Layouts/PostListJourneyLayout/useJourneySlides";

export const PostListJourney = ({
  simpleBlockItems,
  contentProps,
  stepperGoToNext,
}: BlockProps) => {
  const { slides, isPending } = useJourneySlides(simpleBlockItems);

  if (isPending) {
    return <BlockSkeleton type="post-list-journey" />;
  }

  if (!slides.length) {
    return null;
  }

  return (
    <div className="post-list-journey-root">
      <PostListJourneyLayout
        cards={slides}
        blockSlug={contentProps.slug}
        lastSlideRedirection={stepperGoToNext}
      />
    </div>
  );
};
